<template>
    <div>
        <header-nav />
        <div class="download">
            <div
                :class="[
                    'down-center',
                    isDownAni ? 'animationRTL' : 'before-animation'
                ]"
            >
                <img
                    class="big-phone"
                    src="@/images/apphome/phone.png"
                    alt=""
                />
                <div class="detail">
                    <h1>欢迎下载百度健康移动版</h1>
                    <h3>海量医生，在线答疑</h3>
                    <div class="down">
                        <img
                            class="twoimg"
                            src="@/images/apphome/twoimg.png"
                            alt=""
                        />
                    </div>
                    <div class="download-gorup">
                        <a href="https://apps.apple.com/cn/app/%E7%99%BE%E5%BA%A6%E5%81%A5%E5%BA%B7/id1555616850">
                            <img
                                class="iphone"
                                src="@/images/apphome/苹果ios.png"
                                style="margin-bottom: 10px"
                            />
                        </a>
                        <a
                            href="https://med-fe.cdn.bcebos.com/app/apk/bdhealth-1.0.apk"
                            download="bdhealth-1.0.apk"
                        >
                            <img
                                class="android"
                                src="@/images/apphome/安卓.png"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="askdoctor">
            <div
                :class="[
                    'ask-center',
                    isAskAni ? 'animationLTR' : 'before-animation'
                ]"
            >
                <div class="detail">
                    <h1>0元问诊</h1>
                    <h3>数十万名医 24小时在线 分钟级响应</h3>
                </div>
                <div>
                    <img
                        class="twoimg"
                        src="@/images/apphome/问诊.png"
                        alt=""
                    />
                </div>
            </div>
        </div>
        <div class="shopping-mall">
            <div
                :class="[
                    'shopping-center',
                    isShoppingAni ? 'animationRTL' : 'before-animation'
                ]"
            >
                <div>
                    <img
                        class="twoimg"
                        src="@/images/apphome/购药.png"
                        alt=""
                    />
                </div>
                <div class="detail">
                    <h1>健康商城</h1>
                    <h3>正品保障 急速送达 全品类好货优惠购</h3>
                </div>
            </div>
        </div>
        <div class="register">
            <div
                :class="[
                    'register-center',
                    isRegisterAni ? 'animationLTR' : 'before-animation'
                ]"
            >
                <div class="detail" style="margin-left: 180px">
                    <h1>网上挂号</h1>
                    <h3>全网号源聚合 万家医院覆盖</h3>
                </div>
                <div>
                    <img
                        class="twoimg"
                        src="@/images/apphome/挂号.png"
                        alt=""
                    />
                </div>
            </div>
        </div>
        <div class="vaccines">
            <div
                :class="[
                    'vaccines-center',
                    isVaccinesAni ? 'animationRTL' : 'before-animation'
                ]"
            >
                <div>
                    <img
                        class="twoimg"
                        src="@/images/apphome/疫苗.png"
                        alt=""
                    />
                </div>
                <div class="detail">
                    <h1>疫苗服务</h1>
                    <h3>即约即种 随时退改 正品保障</h3>
                </div>
            </div>
        </div>
        <app-footer />
    </div>
</template>

<script>
import HeaderNav from '@/components/app/Header';
import AppFooter from '@/components/app/Footer';

export default {
    components: {
        HeaderNav,
        AppFooter
    },
    data() {
        return {
            downDeforeAni: true,
            isDownAni: false,
            isAskAni: false,
            isShoppingAni: false,
            isRegisterAni: false,
            isVaccinesAni: false
        };
    },
    mounted() {
        this.check();
        window.addEventListener('scroll', this.check, true);
    },
    beforeRouteLeave(to, from, next) {
        window.removeEventListener('scroll', this.check, true);
        next();
    },
    computed: {},
    methods: {
        check() {
            this.isDownAni = this.isDownAni || this.isView('down-center');
            this.isAskAni = this.isAskAni || this.isView('ask-center');
            this.isShoppingAni = this.isShoppingAni || this.isView('shopping-center');
            this.isRegisterAni = this.isRegisterAni || this.isView('register-center');
            this.isVaccinesAni = this.isVaccinesAni || this.isView('vaccines-center');
        },
        isView(className) {
            let element = document.getElementsByClassName(className)[0];
            let offsetTop = element.offsetTop;
            let scrollTop = document.documentElement.scrollTop;
            const viewPortHeight = window.innerHeight
                                    || document.documentElement.clientHeight
                                    || document.body.clientHeight;
            const top = offsetTop - scrollTop;
            if (200 <= viewPortHeight - top) {
                return true;
            }
            return false;
        },
    }
};
</script>

<style lang="less" scoped>

body {
    min-width: 1000px;
}
.download {
    background-image: linear-gradient(to bottom, #f2f5f8, #fff);
    .down-center {
        width: 1000px;
        margin: 0 auto;
        height: 501px;
        overflow: hidden;
        position: relative;
        .big-phone {
            width: 34%;
            margin-top: 40px;
            margin-left: 8%;
            float: left;
        }
        .detail {
            width: 50%;
            position: absolute;
            top: 31%;
            left: 50%;
            line-height: 1.5;
            h1 {
                font-size: 38px;
            }
            h3 {
                font-size: 23px;
                font-weight: 350;
                color: #333;
            }
            .down {
                margin-top: 0px;
            }
            .twoimg {
                margin-top: 5%;
                width: 24%;
                float: left;
            }
            .download-gorup {
                width: 40%;
                float: left;
                height: 120px;
                margin-top: 5%;
                margin-left: 10%;
                display: flex;
                flex-wrap: wrap;
                align-content: space-between;
                a {
                    display: flex;
                }
                img {
                    width: 90%;
                }
            }
        }
    }
}
.askdoctor {
    background-image: linear-gradient(to bottom, #f2f5f8, #fff);
    overflow: hidden;
    .ask-center {
        width: 1200px;
        height: 501px;
        margin: 0 auto;
        img {
            width: 460px;
            float: left;
            margin-top: 50px;
        }
        .detail {
            float: left;
            width: 400px;
            margin-left: 160px;
            margin-top: 200px;
            line-height: 1.5;
            h1 {
                font-size: 36px;
                color: #222;
            }
            h3 {
                font-size: 24px;
                font-weight: 400;
                color: #333;
            }
        }
    }
}
.shopping-mall {
    background-image: linear-gradient(to bottom, #f2f5f8, #fff);
    overflow: hidden;
    .shopping-center {
        width: 1200px;
        height: 501px;
        margin: 0 auto;
        img {
            width: 480px;
            float: left;
            margin-top: 50px;
            margin-left: 200px;
        }
        .detail {
            float: left;
            width: 400px;
            margin-left: 20px;
            margin-top: 180px;
            line-height: 1.5;
            h1 {
                font-size: 36px;
                color: #222;
            }
            h3 {
                font-size: 24px;
                font-weight: 400;
            }
        }
    }
}
.register {
    background-image: linear-gradient(to bottom, #f2f5f8, #fff);
    overflow: hidden;
    .register-center {
        width: 1200px;
        height: 501px;
        margin: 0 auto;
        img {
            width: 460px;
            float: left;
            margin-top: 50px;
        }
        .detail {
            float: left;
            width: 400px;
            margin-left: 160px;
            margin-top: 200px;
            line-height: 1.5;
            h1 {
                font-size: 36px;
                color: #222;
            }
            h3 {
                font-size: 24px;
                font-weight: 400;
                color: #333;
            }
        }
    }
}
.vaccines {
    background-image: linear-gradient(to bottom, #f2f5f8, #fff);
    overflow: hidden;
    .vaccines-center {
        width: 1200px;
        height: 501px;
        margin: 0 auto;
        img {
            width: 480px;
            float: left;
            margin-top: 50px;
            margin-left: 200px;
        }
        .detail {
            float: left;
            width: 400px;
            margin-left: 20px;
            margin-top: 180px;
            line-height: 1.5;
            h1 {
                font-size: 36px;
                color: #222;
            }
            h3 {
                font-size: 24px;
                font-weight: 400;
            }
        }
    }
}
.animationRTL {
    animation: RTL 0.83s ease none;
}
.animationLTR {
    animation: LTR 0.83s ease none;
}
@keyframes RTL{
    0%{
        transform: translateX(100%);
    }
    100%{
        transform: translateX(0);
    }
}
@keyframes LTR{
    0%{
        transform: translateX(-100%);
    }
    100%{
        transform: translateX(0);
    }
}
.before-animation{
    transform: translateX(-200%);
}
</style>


// WEBPACK FOOTER //
// src/pages/app/apphome.vue